'use client';

import dynamicLoad from 'next/dynamic';

export const SuperstarGalleryLazy = dynamicLoad(
  () =>
    import(
      '@wwe-portal/web/components/superstar-search/superstar-gallery'
    ).then((mod) => mod.SuperstarGallery),
  {
    ssr: false,
  }
);
